module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPwAAABDCAIAAAA3Vf+QAAAAA3NCSVQICAjb4U/gAAAAEHRFWHRTb2Z0d2FyZQBTaHV0dGVyY4LQCQAAAJ1JREFUeNrt3TERAAAIAzHAv7DKwgckErgfutFJCj4ZJ0D0IHoQPYgeRA+iB9GD6EH0IHoQPYgeRA+iB9EjehA9iB5ED6IH0YPoQfQgehA9iB5ED6IH0YPoET0AF7VPJJg3IHoQPYgeRA+iB9GD6EH0IHoQPYgeRA+iB9EjehA9iB5ED6IH0YPoQfQgehA9iB5ED6IH0YPoET2IHi5apasFM6rG/3sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./admin/src/images/wp-record-level.png
// module id = 484
// module chunks = 1